import { Link } from 'react-router-dom';
import { AppShell, PageHeader, PageTitle } from '@/components/layout';
import { Icon, PixIcon } from '@/components/foundations';
import { ChartLegend, LineChart } from '@/components/charts';
import { DataTable, Panel, StatCard, StatusBadge, SummaryList } from '@/components/data';
import { Notice } from '@/components/feedback';
import { RECENT_TX, SALES_BY_DAY } from '@/mocks/merchant';

const X_TICKS = [
  { index: 0, label: '1 Mai', dx: -6 },
  ...[4, 8, 12, 16, 20, 24].map((i) => ({ index: i, label: `${i + 1} Mai` })),
  { index: 28, label: '29 Mai', dx: -6 },
  { index: 30, label: '31 Mai', dx: 6 },
];

function CardFilled() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="3" fill="#1a2442" />
      <path d="M3 10h18" stroke="#fff" strokeWidth="1.6" />
      <path d="M6.5 15h3" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

/** Visão geral do lojista — fiel a design/html/index.html (dados mock). */
export function DashboardPage() {
  return (
    <AppShell>
      <main className="content">
  <PageHeader subtitle="Bem-vindo ao seu painel, acompanhe seu desempenho." />
  <PageTitle title="Visão geral" />
  <section className="stats" aria-label="Indicadores">
    <StatCard icon="coin" label="Vendas" value="R$ 24.860,50" trend={{ dir: 'up', value: '12,4%', text: 'vs mês anterior' }} />
    <StatCard icon="shieldCheck" label="Pagamentos aprovados" value="R$ 23.420,00" trend={{ dir: 'up', value: '11,7%', text: 'vs mês anterior' }} />
    <StatCard icon="trendDots" label="Taxa de aprovação" value="98,6%" trend={{ dir: 'up', value: '0,8 p.p.', text: 'vs mês anterior' }} />
    <StatCard icon="wallet" label="A receber" value="R$ 21.437,80" link={{ to: '/transacoes', label: 'Ver detalhes' }} />
  </section>
  <section className="dash-grid">
    <Panel title="Vendas" action={<label className="dropdown sm">Agrupado por dia<Icon name="down" /></label>}>
      <div className="chart"><LineChart label="Gráfico de vendas por dia em maio" series={[{ label: 'Vendas', values: SALES_BY_DAY, color: '#e0a734', areaColor: '#e8b752' }]} pointLabels={SALES_BY_DAY.map((_, i) => `${i + 1} mai`)} xTicks={X_TICKS} /></div>
      <ChartLegend items={[{ label: 'Vendas', value: 'R$ 24.860,50' }]} compare={{ label: <>Mês<br />anterior</>, ariaLabel: 'Comparar com mês anterior', value: 'R$ 22.112,30' }} />
    </Panel>
    <Panel title="Resumo do período">
      <SummaryList
        items={[
          { label: 'Total de vendas', value: 'R$ 24.860,50' },
          { label: 'Total de taxas', value: '- R$ 1.440,50' },
          { label: 'Reembolsos', value: '- R$ 320,00' },
        ]}
        total={{ label: 'Total líquido', value: 'R$ 23.100,00' }}
      />
      <Notice trailingIcon="swap">Parabéns! Suas vendas cresceram<br />12,4% em relação ao mês anterior.</Notice>
    </Panel>
  </section>
  <Panel as="section" variant="recent" title="Transações recentes" action={<Link to="/transacoes">Ver todas as transações <Icon name="chev" /></Link>}>
    <DataTable
      rows={RECENT_TX}
      rowKey={(t) => t.id}
      columns={[
        { key: 'id', header: 'ID da transação', hideOnMobile: true, render: (t) => t.id },
        { key: 'date', header: 'Data', cellClassName: 'wrap', render: (t) => <>{t.date} &nbsp;{t.time}</> },
        { key: 'cli', header: 'Cliente', render: (t) => t.cli },
        { key: 'method', header: 'Método de pagamento', hideOnMobile: true, render: (t) => <span className="method"><span className="mi">{t.kind === 'pix' ? <PixIcon /> : <CardFilled />}</span>{t.kind === 'pix' ? 'Pix' : `Cartão •••• ${t.last}`}</span> },
        { key: 'st', header: 'Status', hideOnMobile: true, render: () => <StatusBadge status="ok" dot /> },
        { key: 'val', header: 'Valor', align: 'right', render: (t) => t.val },
        { key: 'go', header: '', align: 'right', hideOnMobile: true, render: () => <Icon name="chev" className="chev-c" /> },
      ]}
    />
  </Panel>
</main>
    </AppShell>
  );
}
